import React, { useEffect, useState } from 'react';
import { userAppData } from '../MainApp.js';
import { SEC_ApiCall } from '../func.js';
import { ApiError } from '../common/apiError.js';
import LoadingComp from '../common/loading.js';

/** Do not mount a tool until a fresh server response confirms its individual grant. */
export default function ToolAccessGuard({ guid, children }) {
    const [status, setStatus] = useState('loading');
    useEffect(() => {
        let active = true;
        SEC_ApiCall('perms/').then(response => {
            if (!active) return;
            const data = response?.toolsData;
            const allowed = Number(data?.perms ?? 0) === 1 && Array.isArray(data?.allowedTools) && data.allowedTools.includes(guid);
            if (data) userAppData.toolsData = data;
            if (typeof response?.email === 'string') userAppData.email = response.email;
            setStatus(allowed ? 'allowed' : 'denied');
        }).catch(() => { if (active) setStatus('error'); });
        return () => { active = false; };
    }, [guid]);
    if (status === 'loading') return <LoadingComp />;
    if (status !== 'allowed') return <ApiError message={status === 'denied' ? 'You do not have access to this tool. Contact your school administrator.' : 'Tool access could not be checked. Please reopen the tool to try again.'} />;
    return children;
}
